import React from 'react';
import './About.css';
import Header from '../Header/Header';
import aboutVector from './../../assets/about_vector.png';
import Footer from "../../components/Footer/Footer";
import { about_me, about_heading, greeting } from '../../../src/profile';
import AboutLeft from '../About/AboutLeft';

function About() {
  return (
    <div className="section-container fade-in">
      <Header
        heading={about_heading.title}
        details={about_heading.description}
      />

      <div className="about-main">
        {/* Left Side: Services / Roles Grid */}
        <div className="about-main-left">
          <div className="about-roles-container">
            {about_me.map((about) => (
              <AboutLeft 
                title={about.title} 
                description={about.description} 
                link={about.link} 
                key={about.id}
              />
            ))}
          </div>
        </div>

        {/* Right Side: Animated Character Illustration */}
        <div className="about-main-right">
          <div className="about-visual-card glass-card">
            <div className="about-card-glow"></div>
            <img
              src={greeting.about_us}
              alt="Programming character animation"
              className="about-anime"
            />
          </div>
        </div>
      </div>

      <Footer
        title="Check out my 👉 "
        link="projects!"
        toAdress="/projects"
      />

      {/* Decorative Vector Frame */}
      <div className="vector-frame">
        <img src={aboutVector} className="about-vector" alt="" />
      </div>
    </div>
  );
}

export default About;
